import React from 'react';
import { InputLabel, MenuItem, FormControl, Select, useTheme } from '@mui/material';
import { getStyles } from '../../helper';

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 170,
    },
  },
};

function SelectComponent(props) {
  const {
    handleHover,
    handleChange,
    width,
    renderData,
    className,
    valueObj = {},
    name,
    label,
  } = props;

  const theme = useTheme();

  return ( // eslint-disable-next-line
    <FormControl sx={{ width, m: 1 }} size="small" >
      <InputLabel id="demo-simple-select-autowidth-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={valueObj[name]}
        label={label}
        onChange={handleChange}
        name={name}
        MenuProps={MenuProps}
        className={className}
        data-testid="select-component">
        {(renderData || []).map((val) => (
          <MenuItem
            key={val.id}
            value={val.id}
            style={getStyles(val.id, valueObj[name], theme)}
            className="d-block"
            onMouseOver={() => handleHover && handleHover('type', val)}
          >
            {val.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectComponent;
